export default { 
  setClubes ({ commit }, clubes) {
    commit('SET_CLUBES', clubes)
  }
}